import ServicePlanAssetItem from "./ServicePlanAssetItem";
import _Model from "./_Model";

export default class ServicePlanAsset extends _Model {
  constructor(json) {
    super(json);
    this.servicePlanAssetKey = json.servicePlanAssetKey;
    this.value = json.value;
    this.labelKey = json.labelKey;
    this.order = json.order;

    this.servicePlanAssetItems = ServicePlanAsset.getMappedOrDefault(json, 'servicePlanAssetItems', [], data => (data || []).map(a => new ServicePlanAssetItem(a)));
  }
}
